/**
 * KFZ Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { KfzFahrzeugByHsnTsnRequest } from '../model/kfz-fahrzeug-by-hsn-tsn-request.model';
// @ts-ignore
import { KfzFahrzeugDetailsReseponse } from '../model/kfz-fahrzeug-details-reseponse.model';
// @ts-ignore
import { KfzFahrzeugsucheRequest } from '../model/kfz-fahrzeugsuche-request.model';
// @ts-ignore
import { KfzFahrzeugsucheReseponse } from '../model/kfz-fahrzeugsuche-reseponse.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    KfzFahrzeugServiceInterface,
    GetKfzFahrzeugByHsnTsnRequestParams,
    GetKfzFahrzeugmarkenRequestParams,
    GetKfzFahrzeugsucheRequestParams
} from './kfz-fahrzeug.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class KfzFahrzeugService extends BaseService implements KfzFahrzeugServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Autosuche basierend auf HSN und TSN
     * @endpoint post /api/sparte-kfz/fahrzeug-by-hsn-tsn
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getKfzFahrzeugByHsnTsn(requestParameters: GetKfzFahrzeugByHsnTsnRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzFahrzeugDetailsReseponse>;
    public getKfzFahrzeugByHsnTsn(requestParameters: GetKfzFahrzeugByHsnTsnRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzFahrzeugDetailsReseponse>>;
    public getKfzFahrzeugByHsnTsn(requestParameters: GetKfzFahrzeugByHsnTsnRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzFahrzeugDetailsReseponse>>;
    public getKfzFahrzeugByHsnTsn(requestParameters: GetKfzFahrzeugByHsnTsnRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const kfzFahrzeugByHsnTsnRequest = requestParameters?.kfzFahrzeugByHsnTsnRequest;
        if (kfzFahrzeugByHsnTsnRequest === null || kfzFahrzeugByHsnTsnRequest === undefined) {
            throw new Error('Required parameter kfzFahrzeugByHsnTsnRequest was null or undefined when calling getKfzFahrzeugByHsnTsn.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/fahrzeug-by-hsn-tsn`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzFahrzeugDetailsReseponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: kfzFahrzeugByHsnTsnRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Liste der Fahrzeugmarken
     * @endpoint get /api/sparte-kfz/fahrzeugmarken
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getKfzFahrzeugmarken(requestParameters: GetKfzFahrzeugmarkenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public getKfzFahrzeugmarken(requestParameters: GetKfzFahrzeugmarkenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public getKfzFahrzeugmarken(requestParameters: GetKfzFahrzeugmarkenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public getKfzFahrzeugmarken(requestParameters: GetKfzFahrzeugmarkenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;

        let localVarHeaders = this.defaultHeaders;
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/fahrzeugmarken`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<string>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Autosuche basierend auf verschiedenen Parametern
     * @endpoint post /api/sparte-kfz/fahrzeug-suchen
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getKfzFahrzeugsuche(requestParameters: GetKfzFahrzeugsucheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzFahrzeugsucheReseponse>;
    public getKfzFahrzeugsuche(requestParameters: GetKfzFahrzeugsucheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzFahrzeugsucheReseponse>>;
    public getKfzFahrzeugsuche(requestParameters: GetKfzFahrzeugsucheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzFahrzeugsucheReseponse>>;
    public getKfzFahrzeugsuche(requestParameters: GetKfzFahrzeugsucheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const kfzFahrzeugsucheRequest = requestParameters?.kfzFahrzeugsucheRequest;
        if (kfzFahrzeugsucheRequest === null || kfzFahrzeugsucheRequest === undefined) {
            throw new Error('Required parameter kfzFahrzeugsucheRequest was null or undefined when calling getKfzFahrzeugsuche.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/fahrzeug-suchen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzFahrzeugsucheReseponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: kfzFahrzeugsucheRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
